module.exports = __webpack_public_path__ + "40b6-img-grow-1.png";